import React, { useState } from 'react';

import BasicDropdown from '../../common/BasicDropdown/BasicDropdown';

const IntervalTypeDropdown = ({ intervals = [], onValueUpdate = () => {}, disabled = false }) => {
  const [selectedInterval, setSelectedInterval] = useState(intervals[0].id);

  const handleValueUpdate = (value) => {
    setSelectedInterval(value);
    onValueUpdate(value);
  }

  return (
    <BasicDropdown
      className="ml-1"
      buttonLabelSize="md"
      dropdownLabel=""
      values={intervals}
      selectedValue={selectedInterval}
      onValueSelected={handleValueUpdate}
      hideLabelInSmallViewports={false}
      isDisabled={disabled}
    />
  )
}

export default IntervalTypeDropdown;
